module.exports = __webpack_public_path__ + "static/media/Left_Arrow.0e3c2571.svg";